<app-media-grid
  [items]="items"
  [loading]="loading"
  emptyMessage="No videos uploaded yet. Check back soon!"
  emptyIcon="videocam_off"
></app-media-grid>
